import { ACTIVE_CART_ROUTE } from './get-active-cart.service';

import { restApiClient } from '@/datasources';
import { AddCartItemsBody, Cart } from '@/types/cart.types';

export async function addCartItems(body: AddCartItemsBody): Promise<Cart | null> {
  const { data } = await restApiClient.post<Cart | undefined>(ACTIVE_CART_ROUTE, body);

  return data ?? null;
}
